<template>
  <div>
    <div class="reset-password">
      <h3 class="reset-h3">忘记密码</h3>
      <van-field v-model="phone" type="tel" label="手机号" placeholder="请输入手机号" maxlength="11" />
      <van-field
        v-model="code"
        maxlength="6"
        center
        clearable
        label="验证码"
        placeholder="请输入短信验证码"
      >
        <template #button>
          <van-button size="small" type="primary" v-if="count>=90" @click="getCode" native-type="button">发送验证码</van-button>
          <van-button size="small" type="primary" disabled native-type="button" v-else>倒计时 {{count}} s</van-button>
        </template>
      </van-field>
      <van-button type="default" class="reg-btn" @click="resetForm">提交</van-button>
    </div>

    <div class="floating">
      <router-link to>
          <span>
            <svg class="icon" aria-hidden="true" @click="$router.back(-1)">
            <use xlink:href="#icon-return"></use>
          </svg>
          </span>
      </router-link>
    </div>
    <wxNoShare />
  </div>
</template>

<script>
  import { Button, Form, Field } from 'vant'
  export default {
    components: {
      [Button.name]: Button,
      [Form.name]: Form,
      [Field.name]: Field
    },
    name: 'resetPsd',
    data () {
      return {
        phone: '',
        code: '',
        verification_key: '',
        count: 90,
        timer: null,
      }
    },
    methods: {
      formatter(value) {
        // 过滤输入的数字
        return value.replace(/\d/g, '');
      },
      //获取验证码
      getCode() {
        if (!this.phone.length) {
          this.$toast('请输入手机号');
        } else if (!this.common.verifyPhone(this.phone)) {
          // !/^((1[3,5,8,7,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[1,7]))\d{8}$/.test(this.phone)
          this.$toast('请输入正确的手机号码');
          return
        } else {
          // 发送验证码
          this.$api.post('verificationCodes', {phone:this.phone, type:1}, r=>{
            if(r.success === 1){
              this.$toast(r.message)
              this.verification_key = r.data.key
              this.timer = setInterval(()=>{
                this.count --
                if(this.count<=0){
                  clearInterval(this.timer);
                  this.count = 90;
                }
              },1000)
            }
          })
        }
      },
      resetForm() {
        if(this.phone.trim() == ''){
          this.$toast('手机号不能为空')
          return
        }
        if(this.code.trim() == ''){
          this.$toast('短信验证码不能为空')
          return
        }
        this.$api.post('users/checkPone', {phone:this.phone, verification_code: this.code, verification_key: this.verification_key}, r=>{
          if(r.success === 1) {
            sessionStorage.setItem('hashCode', r.data.hashCode)
            this.$router.push({name:'resetForm'})
          }else{
            this.$toast('验证失败')
          }
        })
      }
    },
  }
</script>

<style scoped>
  .reset-password{
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    position: fixed;
    overflow: hidden;
    padding-top:15%;
  }
  .reset-h3{
    text-align: center;
    font-weight: normal;
    font-size: 16px;
  }
  .reg-btn{
    background: #ED6B0D;
    color:#fff;
    width: 80%;
    border-radius: 25px;
    margin: 40px auto 0;
    display: inherit;
  }
</style>



// WEBPACK FOOTER //
// src/views/registers/resetPassword.vue